import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[16/10] overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          title={`${article.title} - 911吃瓜网`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
        {article.isHot && (
          <span className="absolute top-3 right-3 px-2.5 py-1 bg-accent-500 text-white text-xs font-bold rounded-full whitespace-nowrap">
            爆
          </span>
        )}
        {article.isExclusive && !article.isHot && (
          <span className="absolute top-3 right-3 px-2.5 py-1 bg-primary-500 text-white text-xs font-bold rounded-full whitespace-nowrap">
            独家
          </span>
        )}
        <div className="absolute bottom-3 left-3">
          <span className="px-2.5 py-1 bg-white/20 backdrop-blur-sm text-white text-xs rounded-full whitespace-nowrap">
            {article.category}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-base font-heading font-bold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors duration-200">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {article.summary}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span className="whitespace-nowrap">{article.publishDate}</span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line"></i>
            {article.views >= 10000
              ? `${(article.views / 10000).toFixed(0)}万`
              : article.views}
          </span>
        </div>
      </div>
    </Link>
  );
}